"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentPerformanceClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const sdk_constants_1 = require("../../constants/sdk.constants");
const serializers_1 = require("../serializers");
class AssessmentPerformanceClient {
    static newInstance(options, retryOptions) {
        return new AssessmentPerformanceClient(dp_http_client_lib_1.RetryableHttpClient.newInstance(options, retryOptions), new serializers_1.AssessmentPerformanceSerializer(new serializers_1.AssigneePerformanceSerializer(new serializers_1.ItemPerformanceSerializer(new serializers_1.ItemQuestionPerformanceSerializer()), new serializers_1.ItemQuestionPerformanceSerializer())));
    }
    constructor(client, assessmentPerformanceSerializer) {
        this.client = client;
        this.assessmentPerformanceSerializer = assessmentPerformanceSerializer;
    }
    async findByAssessment(assessmentIds, groupBy = 'assessment', headers) {
        const response = await this.client.post(`${sdk_constants_1.ANALYTICS_API_PREFIX}/assessmentPerformance.findByAssessment`, {
            assessmentIds: assessmentIds,
            groupBy,
        }, {
            headers,
        });
        const { data } = response.body;
        return data.map((item) => this.assessmentPerformanceSerializer.serializeOne(item));
    }
    async findByContextAndTemplate(contextIds, assessmentTemplateIds, headers) {
        const response = await this.client.get(`${sdk_constants_1.ANALYTICS_API_PREFIX}/assessmentPerformance.findByContextAndTemplate`, {
            headers,
            params: {
                contextId: contextIds,
                assessmentTemplateId: assessmentTemplateIds,
            },
        });
        const { data } = response.body;
        return data.map((item) => this.assessmentPerformanceSerializer.serializeOne(item));
    }
    async findByContextAndAssignee(contextIds, assigneeIds, assessmentTemplateIds, headers) {
        const response = await this.client.post(`${sdk_constants_1.ANALYTICS_API_PREFIX}/assessmentPerformance.findByContextAndAssignee`, {
            contextIds: contextIds,
            assigneeIds: assigneeIds,
            assessmentTemplateIds: assessmentTemplateIds,
        }, {
            headers,
        });
        const { data } = response.body;
        return data.map((item) => this.assessmentPerformanceSerializer.serializeOne(item));
    }
    async findByAssignee(assigneeId, headers) {
        const response = await this.client.get(`${sdk_constants_1.ANALYTICS_API_PREFIX}/assessmentPerformance.findByAssignee`, {
            headers,
            params: {
                assigneeId,
            },
        });
        const { data } = response.body;
        return data.map((item) => this.assessmentPerformanceSerializer.serializeOne(item));
    }
    async findHighAndLowPerformingByContext(contextId, headers) {
        const response = await this.client.get(`${sdk_constants_1.ANALYTICS_API_PREFIX}/assessmentPerformance.findHighAndLowPerformingByContext`, {
            headers,
            params: {
                contextId,
            },
        });
        return response.body.data;
    }
}
exports.AssessmentPerformanceClient = AssessmentPerformanceClient;
//# sourceMappingURL=assessment-performance.client.js.map